import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TreatmentsComponent } from './treatments.component';

const routes: Routes = [{
  path: '',
  component: TreatmentsComponent,
  children: [
    {
      path: 'realtime',
      loadChildren: 'app/pages/treatments/realtime/realtime.module#RealtimeModule',
    },
    {
      path: 'uploadTreatment',
      loadChildren: 'app/pages/treatments/upload-treatment/upload-treatment.module#UploadTreatmentModule',
    },
    {
      path: '',
      redirectTo: 'realtime',
      pathMatch: 'full',
    },
  ],
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TreatmentsRoutingModule { }
